(function () {
  const ref = sessionStorage.getItem('referrer_temp');
  const now = Date.now();
  const expireAfter = 90 * 60 * 1000; // 90 minutos

  if (ref) {
    localStorage.setItem('referrer', ref);
    localStorage.setItem('valid_discount', 'true');
    localStorage.setItem('referrer_saved_at', now);
    sessionStorage.removeItem('referrer_temp');
    //console.log("✅ Referrer guardado en localStorage:", ref);
  }

  // Caduca a los 90 min
  const savedAt = Number(localStorage.getItem('referrer_saved_at'));
  if (savedAt && now - savedAt > expireAfter) {
    localStorage.removeItem('referrer');
    localStorage.removeItem('valid_discount');
    localStorage.removeItem('referrer_saved_at');
    //console.log("🧹 Referrer expirado");
  } else if (savedAt) {
    const mins = Math.ceil((expireAfter - (now - savedAt))/60000);
    //console.log(`⏳ Referrer activo, expira en ~${mins} min`);
  }
})();

// Al cargar, enganchamos el FORM de carrito para fusionar la nota al SUBMIT
document.addEventListener("DOMContentLoaded", function () {
  const referrer = localStorage.getItem("referrer");
  const valid    = localStorage.getItem("valid_discount");

  if (referrer && valid === "true") {
    const cartForm = document.querySelector('form[action="/cart"]');
    if (!cartForm) return;

    cartForm.addEventListener("submit", function(e) {
      // Fusionamos la nota del usuario + nuestro texto justo antes de enviar
      const noteField = cartForm.querySelector('textarea[name="note"]');
      const refText = `Referido por: ${referrer}`;

      if (noteField) {
        const userNote = noteField.value.trim();
        // Ocultamos nuestra nota, para no mostrarlo al usuario (pagina de carrito /cart)
        noteField.value = userNote
          ? `${refText}\n\n${userNote}`
          : refText;
        //console.log("✍️ Nota final enviada:", noteField.value);
      } else {
        // Si no hay textarea (p.ej. drawer sin nota), creamos uno oculto
        const hiddenNote = document.createElement("input");
        hiddenNote.type = "hidden";
        hiddenNote.name = "note";
        hiddenNote.value = refText;
        cartForm.appendChild(hiddenNote);
        //console.log("✍️ Nota oculta enviada:", refText);
      }
      // Dejamos que el formulario siga su flujo normal
    });
  }
});
